// highlight
import "./utils/highlight";

// scroll bar
import "simplebar/src/simplebar.css";

// lightbox
import "react-image-lightbox/style.css";

// map
import "mapbox-gl/dist/mapbox-gl.css";

// editor
import "react-quill/dist/quill.snow.css";

// slick-carousel
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// lazy image
import "react-lazy-load-image-component/src/effects/blur.css";
import "react-lazy-load-image-component/src/effects/opacity.css";
import "react-lazy-load-image-component/src/effects/black-and-white.css";

//import ReactDOM from "react-dom";
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Provider as ReduxProvider } from "react-redux";
import { PersistGate } from "redux-persist/lib/integration/react";
//import AdapterDateFns from "@mui/lab/AdapterDateFns";
//import LocalizationProvider from "@mui/lab/LocalizationProvider";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { store, persistor } from "./redux/store";
import { SettingsProvider } from "./contexts/SettingsContext";
import { CollapseDrawerProvider } from "./contexts/CollapseDrawerContext";
import { ProjectProvider } from "./contexts/ProjectContext";

import { AuthProvider } from "./contexts/JWTContext";
import App from "./App";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import reportWebVitals from "./reportWebVitals";

import { SnackbarProvider } from "notistack";
import { SnackbarUtilsConfigurator } from "./utils/snackbar";
import { ThirdwebProvider } from "@thirdweb-dev/react";
import { metamaskWallet,
  coinbaseWallet,
  walletConnect,
  localWallet,
  embeddedWallet } from "@thirdweb-dev/react";
const metamaskConfig = metamaskWallet({ recommended: true });
// ----------------------------------------------------------------------
const container = document.getElementById('root');
const root = createRoot(container)
root.render(
  <AuthProvider>
    <HelmetProvider>
      <ReduxProvider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <SettingsProvider>
              <CollapseDrawerProvider>
                <BrowserRouter>
                  <ProjectProvider>
                    <SnackbarProvider
                      maxSnack={3}
                      anchorOrigin={{
                        horizontal: "center",
                        vertical: "bottom",
                      }}
                    >
                      <SnackbarUtilsConfigurator />
                      <ThirdwebProvider activeChain="ethereum" clientId="6e3cb2b0969117caa500c9830c05b2c2" 
                      supportedWallets={[
                        metamaskConfig,
                        coinbaseWallet({ recommended: true }),
                        walletConnect(),
                        localWallet(),
                        embeddedWallet({
                            auth: {
                              options: [
                                "email",
                                "google",
                                "apple",
                                "facebook",
                              ]}})
                            ]}>
                        <App />
                      </ThirdwebProvider>
                    </SnackbarProvider>
                  </ProjectProvider>
                </BrowserRouter>
              </CollapseDrawerProvider>
            </SettingsProvider>
          </LocalizationProvider>
        </PersistGate>
      </ReduxProvider>
    </HelmetProvider>
  </AuthProvider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
